import { useCallback, useContext } from 'react';
import ReportGadgetsContext from '../../../../../../contexts/ReportGadgetsContext';
import isV5ChartDef from '../../../../../../types/visTypeCheckers/isV5ChartDef';

/**
 * Returns a list of V5 simple grid chart definitions that sort by the given field
 */
const useGetFieldSimpleGridSortUsage = () => {
  const { allGadgets } = useContext(ReportGadgetsContext);
  const definitions = allGadgets.map((g) => g.chartDef);

  const getFieldSimpleGridSortUsage = useCallback(
    (field: string, dataset: string) => {
      return definitions.filter((def) => {
        if (!isV5ChartDef(def)) return false;
        if (def.gadgetType !== 'simpleGrid') return false;
        if (def.simpleGridConfig?.dataType !== dataset) return false;

        const sorts = def.simpleGridConfig?.sort || [];

        return sorts.some((s) => s.field === field);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allGadgets],
  );

  return getFieldSimpleGridSortUsage;
};

export default useGetFieldSimpleGridSortUsage;
